const units = {}

/////////////
// RANGER //
///////////

units["dagger"] = {
    "jobKey": "dagger",
    "jobName": "Dagger",
    "fequivalent": "Thief",
    "skills": ["inflict-damage"],
    "element": "dagger",
    "attacktype": "steel",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "daggers"
}

units["bow"] = {
    "jobKey": "bow",
    "jobName": "Bow",
    "fequivalent": "Archer",
    "skills": ["inflict-damage"],
    "element": "bow",
    "attacktype": "steel",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "bow"
}

units["gun"] = {
    "jobKey": "gun",
    "jobName": "Gun",
    "fequivalent": "Pirate",
    "skills": ["inflict-damage"],
    "element": "gun",
    "attacktype": "steel",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "gun"
}

//////////////
// FIGHTER //
////////////

units["sword"] = {
    "jobKey": "sword",
    "jobName": "Sword",
    "fequivalent": "Mercenary",
    "skills": ["inflict-damage"],
    "element": "sword",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "sword"
}

units["spear"] = {
    "jobKey": "spear",
    "jobName": "Spear",
    "fequivalent": "Soldier",
    "skills": ["inflict-damage"],
    "element": "spear",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "spear"
}

units["hammer"] = {
    "jobKey": "hammer",
    "jobName": "Axe", // ??
    "fequivalent": "Fighter",
    "skills": ["inflict-damage"],
    "element": "axe",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "hammer"
}

//////////////////////
// FIGHTER ARMORED //
////////////////////

units["swordknight"] = {
    "jobKey": "swordknight",
    "jobName": "Swordknight",
    "fequivalent": "Swordknight",
    "skills": ["inflict-damage"],
    "element": "sword",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-shield",
    "weaponImageKey": "sword"

    // // specific to chapterB
    // "skills": ["inflict-damage", "swords-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 6,
}

units["spearknight"] = {
    "jobKey": "spearknight",
    "jobName": "Spearknight",
    "fequivalent": "Lancerknight",
    "skills": ["inflict-damage"],
    "element": "spear",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "blue-shield",
    "weaponImageKey": "spear"

    // // specific to chapterB
    // "skills": ["inflict-damage", "swords-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 8,
}

units["hammerknight"] = {
    "jobKey": "hammerknight",
    "jobName": "Axeknight", // ??
    "fequivalent": "Hammerknight",
    "skills": ["inflict-damage"],
    "element": "axe",
    "attacktype": "steel",
    "attackrange": 1,

    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 30,
    "power": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "green-shield",
    "weaponImageKey": "hammer"

    // // specific to chapterB
    // "skills": ["inflict-damage", "sword-up", "shields-up"],
    // "moverange": 2,
    // "defense": 10,
    // "resistance": 5,
    // "power": 8,
}

///////////
// MAGE //
/////////

units["mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "fequivalent": "Mage",
    "skills": ["inflict-damage"],
    "element": "fire",
    "attacktype": "magic",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "red-staff",
}

units["priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    "fequivalent": "Priest",
    "skills": ["inflict-damage"],
    "element": "water",
    "attacktype": "magic",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "blue-staff",
}

units["shaman"] = {
    "jobKey": "shaman",
    "jobName": "Shaman",
    "fequivalent": "Shaman",
    "skills": ["inflict-damage"],
    "element": "earth",
    "attacktype": "magic",
    "attackrange": 2,

    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 5,
    // "attackspeed": 5,
    // "luck": 0,
    "weaponImageKey": "green-staff",
}

units["chest"] = {
    "jobKey": "chest",
    "jobName": "Treasure",
    "type": "thing",
    "health": 10,
    "maxhealth": 30,
    "affiliation": "nothing",
    "imageKey": "chest1",
}

export default units
